"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => {
    const withSubheaderColor = theme.greyTable;
    const headerPadding = '0 21px';
    return {
        root: {
            height: constants_1.HEADER_HEIGHT,
            width: '100%'
        },
        fixed: {
            backgroundColor: withSubheaderColor,
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 4,
            width: '100vw'
        },
        header: {
            height: constants_1.HEADER_HEIGHT,
            width: '100%',
            backgroundColor: theme.white1,
            display: 'flex',
            alignItems: 'center',
            padding: headerPadding,
            boxShadow: theme.indigoShadow1,
            '&[data-has-subheader="true"]': {
                height: constants_1.HEADER_HEIGHT / 2,
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10
            }
        },
        subheader: {
            width: '100%',
            backgroundColor: withSubheaderColor,
            display: 'flex',
            alignItems: 'center',
            padding: headerPadding,
            height: constants_1.HEADER_HEIGHT / 2
        },
        home: {
            flexShrink: 0,
            marginRight: 18,
            height: 18,
            display: 'flex',
            alignItems: 'center',
            appearance: 'none',
            textAlign: 'left',
            backgroundColor: 'inherit',
            border: 'none',
            cursor: 'pointer',
            outline: 'none',
            '&[disabled]': {
                cursor: 'default',
                opacity: '0.5'
            }
        },
        logoText: {
            paddingLeft: 7,
            '& > svg': {
                fill: theme.colorBrandPrimary
            }
        },
        sections: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'space-between',
            opacity: 1,
            transition: 'opacity 250ms linear 250ms',
            '&[aria-busy="true"]': {
                opacity: 0
            }
        },
        animatedLogo: {
            width: 28,
            height: 28,
            flexShrink: 0
        }
    };
};
//# sourceMappingURL=header.style.js.map